<template>
  <div>
    <h1>{{ __('Ange betalningsinfo') }}</h1>

    <payment
      :giftcard="true"
      :authorizing="authorizing"
      :authorizeError="authorizeError"
      @newGiftCard="addGiftCard"
      @authorize="authorize"
    >
      <div class="fix-width text-small margin-bottom-x3">
        {{
          __(
            'Välj någon av ovan alternativ för att gå vidare. Medlemskapet börjar så fort du har angett din betalningsinformation.'
          )
        }}
      </div>
      <div class="pay-details">
        <span class="text-small">{{ __('Totalbelopp inkl. moms:') }}</span
        ><span v-if="currentProduct">{{ getTotalPrice() }} {{ __('kr') }}</span
        ><span
          ><button @click="showDetails = !showDetails">
            {{ showDetails ? __('Dölj') : __('Visa') }} {{ __('detaljer') }}
          </button></span
        >
        <ul :class="!showDetails ? 'hide' : ''">
          <li v-if="currentProduct">
            {{ __('Abonnemang') }} <span>{{ __(currentProduct.name) }}</span>
          </li>
          <li>
            {{ __('Bindningstid') }}
            <span>{{ selectedSubscription }} {{ __('mån') }}</span>
          </li>
          <li>
            {{ __('Månadspris') }}
            <span v-if="currentProduct"
              >{{
                Math.round(
                  currentProduct.prices[selectedSubscriptionId] /
                    selectedSubscription
                )
              }}
              {{ __('kr') }}</span
            >
          </li>
          <li>
            {{ __('Totalpris') }}
            <span>{{ getTotalPrice() }} {{ __('kr') }}</span>
          </li>
        </ul>
      </div>
    </payment>
  </div>
</template>

<script>

import updateQuery from '@/mixins/updateQuery'
import logScope from 'log-scope'
const log = logScope('step4')

export default {
  data () {
    return {
      showDetails: false,
      authorizing: false,
      authorizeError: '',
      giftCard: null,
      orderId: null,
    }
  },
  components: {
    Payment: () => import('@/components/Payment.vue'),
  },
  mounted () {
    this.$store.commit('setGiftCard', this.giftCard)
    this.orderId = this.$store.getters.currentOrderId
    if (!this.orderId) this.$router.push('/signup?step=2')
  },
  mixins: [updateQuery],
  computed: {
    availableSubscriptions () {
      return this.$store.getters.availableSubscriptions
    },
    selectedSubscription () {
      return this.availableSubscriptions[this.selectedSubscriptionId]
    },
    availableProducts () {
      return this.$store.getters.availableProducts
    },
    currentProduct () {
      return this.$store.getters.currentProduct
    },
    currentProductId () {
      return this.$route.query['product']
    },
    selectedSubscriptionId () {
      return this.$route.query['subscription']
    },
  },
  methods: {
    getTotalPrice () {
      if (!this.currentProduct) return ''
      let total = this.currentProduct.prices[this.selectedSubscriptionId]
      if (this.giftCard) {
        if (this.giftCard.suffix === 'kr') {
          let num = Number(total - this.giftCard.amount)
          if (num < 0) num = 0
          return num.toFixed(2)
        } else if (this.giftCard.suffix === '%') {
          let num = Number(total - total * (this.giftCard.amount / 100))
          if (num < 0) num = 0
          return num.toFixed(2)
        } else {
          return Number(total).toFixed(2)
        }
      } else {
        return total
      }
    },
    addGiftCard (giftCard) {
      this.isPriceReady = false
      this.giftCard = giftCard
      this.$store.commit('setGiftCard', this.giftCard)
      this.isPriceReady = true
    },
    async authorize (paymentId) {
      try {
        this.authorizeError = ''
        this.authorizing = true
        this.$store.commit('setPaymentId', this.paymentId)
        /*
        let giftCardName = null
        if (this.giftCard && this.giftCard.name) { giftCardName = this.giftCard.name }

        await userHandler.authorizeOrder({
          id: this.orderId,
          product: this.currentProduct.id,
          subscription: this.selectedSubscriptionId,
          giftCard: giftCardName,
          paymentId,
        })
        */
        this.$store.commit('setOrderId', null)
        this.authorizing = false
        this.$emit('input', 5)
      } catch (err) {
        this.authorizing = false

        let msg = ''

        if (err.response.data) {
          const customError = err.response.data
          if (customError.includes('id[3000]')) {
            msg = 'Ingen order hittades. Testa uppdatera sidan.'
          } else if (customError.includes('id[3010]')) {
            msg = 'Vänligen välj produkt.'
          } else if (customError.includes('id[3011]')) {
            msg = 'Vänligen välj månadsplan.'
          } else if (customError.includes('id[3012]')) {
            msg = 'Vänligen välj betalsätt.'
          } else if (customError.includes('id[2000]')) {
            msg = 'Sessionen gäller ej längre. Vänligen logga in på nytt.'
          } else {
            msg = 'Serverfel, kontakta oss om felet uppstår igen.'
          }
        } else {
          msg = err.message
        }
        this.authorizeError = this.__(msg || err)
        log.error(err)
      }
    },
  },
}
</script>
<style lang="less">
@import '../../style/variables.less';
.pay-details {
  display: flex;
  flex-direction: column;
  margin-bottom: 2em;
  > span:nth-child(2) {
    font-family: Oswald;
    color: white;
    font-weight: bold;
    font-size: 1.6em;
  }
  ul {
    list-style: none;
    margin: 2em 0;
    border: 1px solid @color-grey-light;
    transition: max-height 0.5s;
    max-height: 300px;
    overflow: hidden;
    padding: 0;
    li {
      margin: 5px 20px;
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      span {
        color: white;
      }
    }
    li:not(:last-child) {
      border-bottom: 1px solid @color-grey;
    }
  }
  .hide {
    max-height: 0;
    border: none;
    margin: 0;
  }
}
</style>
